import React from "react";
import { ErrorMessage, useField } from "formik";

import "../../Common/Common.css";

export const DropDown = ({
  label,
  defValue,
  isRequired,
  data = [],
  ...props
}) => {
  const [field, meta] = useField(props);

  return (
    <div className="mb-2">
      <label htmlFor={field.name} className="label-inpt">
        {label}
        {isRequired && <span className="astrk"> * </span>}
      </label>
      <select
        className={`form-control shadow-none  inpt-txt-size`}
        style={{ textTransform: "capitalize", background: "#ffffff" }}
        {...field}
        {...props}
        autoComplete="off"
      >
        <option value="" descp="" className="selectClass">
          {defValue}
        </option>
        {data.length &&
          data.map((item, i) => {
            return (
              <option key={i} value={item.id} className="selectClass">
                {item.name || item.pincode || (item.userId && item.userId.name)||(item.countryId&&item.countryId.name)}
              </option>
            );
          })}
      </select>
      {meta.error ? (
        <ErrorMessage component="div" name={field.name} className="errorMsg" />
      ) : null}
    </div>
  );
};
